export default __webpack_public_path__ + "static/media/PAYROLL_Final-Image.c7a6c975.png";